// export const MenuList = [
// // 1 Dashboard
// {
// title: "Dashboard",
// iconStyle: <i className="fas fa-tachometer-alt" />,
// to: "/dashboard",
// allowedRoles: ['Admin','Manager','Engineer','Client','PO','Billing','HR']
// },

// // 2 Projects
// // (No specific "Projects" menu in your data, so we keep existing related modules after Dashboard)

// // 3 Billing
// {
// title: "Billings",
// iconStyle: <i className="fas fa-file-invoice-dollar" />,
// to: "billings",
// allowedRoles: ['Admin','Billing','Client']
// },

// // 4 HR
// // =======================
// // HR MODULE (FUTURE USE)
// // =======================

// // {
// // title: "HR",
// // iconStyle: <i className="fas fa-user-shield" />,
// // allowedRoles: ['Admin','HR','Manager'],
// // content: [
// // { title: "Employees", to: "employees", allowedRoles: ['Admin','HR'] },
// // { title: "Attendance", to: "attendance", allowedRoles: ['Admin','HR','Manager'] },
// // { title: "Leaves & Holidays", to: "leaves", allowedRoles: ['Admin','HR'] },
// // { title: "Payroll", to: "payroll", allowedRoles: ['Admin','HR'] },
// // { title: "Departments", to: "departments", allowedRoles: ['Admin','HR'] },
// // { title: "Designations", to: "designations", allowedRoles: ['Admin','HR'] },
// // ],
// // },

// {
// title: "Users",
// iconStyle: <i className="fas fa-user-cog" />,
// allowedRoles: ['Admin'],
// content: [
// { title: "Users", to: "/users" },
// { title: "User Profile", to: "user-profile" },
// { title: "Roles", to: "roles" },
// { title: "Permissions", to: "permissions" },
// {title :"RolePermissions", to:"role-permissions"}
// ],
// },

// // 5 Purchase
// {
// title: "Material",
// iconStyle: <i className="fas fa-boxes" />,
// allowedRoles: ['Admin','Manager','Engineer','PO'],
// content: [
// { title: "Indent", to: "indent", allowedRoles: ['Admin','Manager','Engineer'] },
// { title: "Purchase Orders", to: "purchase-orders", allowedRoles: ['Admin','PO'] },
// { title: "Delivery", to: "delivery", allowedRoles: ['Admin','Manager','Engineer','PO'] },
// { title: "MIR", to: "mir", allowedRoles: ['Admin','Manager','Engineer','PO'] },
// ],
// },

// // 6 Contracts
// {
// title: "ITC",
// iconStyle: <i className="fas fa-file-signature" />,
// allowedRoles: ['Admin','Manager','Engineer'],
// content: [
// { title: "JMR", to: "jmr", allowedRoles: ['Admin','Manager','Engineer'] },
// { title: "TC Report", to: "tc-report", allowedRoles: ['Admin','Manager','Engineer'] },
// ],
// },

// {
// title: "Handover",
// iconStyle: <i className="fas fa-handshake" />,
// to: "handover",
// allowedRoles: ['Admin','Manager','Engineer','Client']
// },

// // 7 DPR
// {
// title: "DPR",
// iconStyle: <i className="fas fa-clipboard-check" />,
// to: "dpr",
// allowedRoles: ['Admin','Manager','Engineer']
// },

// // 8 Work Orders
// {
// title: "Work Orders",
// iconStyle: <i className="fas fa-tasks" />,
// to: "work-orders",
// allowedRoles: ['Admin','Manager','Engineer','Client','PO','Billing','HR']
// },

// // 9 Documents
// {
// title: "Documents",
// iconStyle: <i className="fas fa-file-alt" />,
// to: "documents",
// allowedRoles: ['Admin','Manager','Engineer','Client','PO','Billing']
// },

// // Employee CRM / Task
// {
// title: "Task",
// iconStyle: <i className="fas fa-clipboard-list" />,
// to: "/task",
// allowedRoles: ['Admin','Manager','Engineer','Client','PO','Billing','HR']
// },
// {
// title: "Employee CRM",
// iconStyle: <i className="fas fa-users" />,
// to: "/employee-crm",
// allowedRoles: ['Admin','HR','Manager']
// },

// // Vendors (Supports Purchase module)
// {
// title: "Vendors",
// iconStyle: <i className="fas fa-user-tie" />,
// allowedRoles: ['Admin','PO'],
// content: [
// { title: "Vendors", to: "vendors", allowedRoles: ['Admin','PO'] },
// { title: "Vendor Categories", to: "vendor-categories", allowedRoles: ['Admin','PO'] },
// ],
// },

// // Teams (HR support)
// {
// title: "Teams",
// iconStyle: <i className="fas fa-users-cog" />,
// allowedRoles: ['Admin'],
// to: "/teams",
// },

// // Clients (Billing support)
// {
// title: "Clients",
// iconStyle: <i className="fas fa-user-friends" />,
// allowedRoles: ['Admin','PO','Billing'],
// to: "/clients",
// },

// // Masters (Admin configs)
// {
// title: "Masters",
// iconStyle: <i className="fas fa-layer-group" />,
// allowedRoles: ['Admin'],
// content: [
// { title: "Document Types", to: "document-types", allowedRoles: ['Admin'] },
// ],
// },


// // {
// // title: 'Dashboard',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-home" />,
// // content: [

// // {
// // title: 'Dashboard Light',
// // to: '/dashboard',
// // },
// // {
// // title: 'Dashboard Dark',
// // to: 'dashboard-dark',
// // },
// // {
// // title: 'Draggable',
// // to: 'draggable',
// // },
// // {
// // title: 'Clients',
// // to: 'clients',
// // },
// // {
// // title: 'Project Details',
// // to: 'project-details',
// // },
// // 		{
// // title: 'Messages',
// // to: 'messages',
// // },
// // 		{
// // title: 'Latest Activity',
// // to: 'latest-activity',
// // },
// // 		{
// // title: 'Task',
// // to: 'task',
// // },

// // ],
// // },

// // //Apps
// // {
// // title: 'Apps',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-info-circle" />,
// // content: [
// // {
// // title: 'Profile',
// // to: 'app-profile'
// // },

// // {
// // title: 'Post Details',
// // to: 'post-details'
// // },
// // {
// // title: 'Email',
// // hasMenu : true,
// // to:"#",
// // content: [
// // {
// // title: 'Compose',
// // to: 'email-compose',
// // },
// // {
// // title: 'Index',
// // to: 'email-inbox',
// // },
// // {
// // title: 'Read',
// // to: 'email-read',
// // }
// // ],
// // },
// // {
// // title:'Calendar',
// // to: 'app-calender'
// // },
// // {
// // title: 'Shop',
// // to: '#',
// // hasMenu : true,
// // content: [
// // {
// // title: 'Product Grid',
// // to: 'ecom-product-grid',
// // },
// // {
// // title: 'Product List',
// // to: 'ecom-product-list',
// // },
// // {
// // title: 'Product Details',
// // to: 'ecom-product-detail',
// // },
// // {
// // title: 'Order',
// // to: 'ecom-product-order',
// // },
// // {
// // title: 'Checkout',
// // to: 'ecom-checkout',
// // },
// // {
// // title: 'Invoice',
// // to: 'ecom-invoice',
// // },
// // {
// // title: 'Customers',
// // to: 'ecom-customers',
// // },
// // ],
// // },
// // ],
// // },
// // // //Charts
// // {
// // title: 'Charts',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-chart-line" />,
// // content: [

// // {
// // title: 'RechartJs',
// // to: 'chart-rechart',
// // },
// // {
// // title: 'Chartjs',
// // to: 'chart-chartjs',
// // },
// // {
// // title: 'Sparkline',
// // to: 'chart-sparkline',
// // },
// // {
// // title: 'Apexchart',
// // to: 'chart-apexchart',
// // },
// // ]
// // },
// // //Boosttrap
// // {
// // title: 'Bootstrap',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fab fa-bootstrap" />,
// // content: [
// // {
// // title: 'Accordion',
// // to: 'ui-accordion',
// // },
// // {
// // title: 'Alert',
// // to: 'ui-alert',
// // },
// // {
// // title: 'Badge',
// // to: 'ui-badge',
// // },
// // {
// // title: 'Button',
// // to: 'ui-button',
// // },
// // {
// // title: 'Modal',
// // to: 'ui-modal',
// // },
// // {
// // title: 'Button Group',
// // to: 'ui-button-group',
// // },
// // {
// // title: 'List Group',
// // to: 'ui-list-group',
// // },
// // {
// // title: 'Cards',
// // to: 'ui-card',
// // },
// // {
// // title: 'Carousel',
// // to: 'ui-carousel',
// // },
// // {
// // title: 'Dropdown',
// // to: 'ui-dropdown',
// // },
// // {
// // title: 'Popover',
// // to: 'ui-popover',
// // },
// // {
// // title: 'Progressbar',
// // to: 'ui-progressbar',
// // },
// // {
// // title: 'Tab',
// // to: 'ui-tab',
// // },
// // {
// // title: 'Typography',
// // to: 'ui-typography',
// // },
// // {
// // title: 'Pagination',
// // to: 'ui-pagination',
// // },
// // {
// // title: 'Grid',
// // to: 'ui-grid',
// // },
// // ]
// // },
// // //plugins
// // {
// // title:'Plugins',
// // classsChange: 'mm-collapse',
// // iconStyle : <i className="fas fa-heart" />,
// // content : [
// // {
// // title:'Select 2',
// // to: 'uc-select2',
// // },
// // // {
// // // title:'Noui Slider',
// // // to: 'uc-noui-slider',
// // // },
// // {
// // title:'Sweet Alert',
// // to: 'uc-sweetalert',
// // },
// // {
// // title:'Toastr',
// // to: 'uc-toastr',
// // },
// // {
// // title:'Jqv Map',
// // to: 'map-jqvmap',
// // },
// // {
// // title:'Light Gallery',
// // to: 'uc-lightgallery',
// // },
// // ]
// // },
// // //Widget
// // {
// // title:'Widget',
// // //classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-user-check" />,
// // to: '/widget-basic',
// // },
// // //Forms
// // {
// // title:'Forms',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-file-alt" />,
// // content : [
// // {
// // title:'Form Elements',
// // to: 'form-element',
// // },
// // {
// // title:'Wizard',
// // to: 'form-wizard',
// // },
// // {
// // title:'CkEditor',
// // to: 'form-ckeditor',
// // },
// // {
// // title:'Pickers',
// // to: 'form-pickers',
// // },
// // {
// // title:'Form Validate',
// // to: 'form-validation',
// // },

// // ]
// // },
// // //Table
// // {
// // title:'Table',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-table"/>,
// // content : [
// // {
// // title:'Table Filtering',
// // to: 'table-filtering',
// // },
// // {
// // title:'Table Sorting',
// // to: 'table-sorting',
// // },
// // {
// // title:'Bootstrap',
// // to: 'table-bootstrap-basic',
// // },

// // ]
// // },
// // //Pages
// // {
// // title:'Pages',
// // classsChange: 'mm-collapse',
// // iconStyle: <i className="fas fa-clone" />,
// // content : [
// // {
// // title:'Error',
// // hasMenu : true,
// // to:"#",
// // content : [
// // {
// // title: 'Error 400',
// // to : 'page-error-400',
// // },
// // {
// // title: 'Error 403',
// // to : 'page-error-403',
// // },
// // {
// // title: 'Error 404',
// // to : 'page-error-404',
// // },
// // {
// // title: 'Error 500',
// // to : 'page-error-500',
// // },
// // {
// // title: 'Error 503',
// // to : 'page-error-503',
// // },
// // ],
// // },
// // {
// // title:'Lock Screen',
// // to: 'page-lock-screen',
// // },

// // ]
// // },
// ];
// menus.js - Complete RBAC Menu Loader with Cache Management
import React from "react";
import api from "../../../api";

let cachedMenus = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Invalidate menu cache (call on role change/login)
 */
export const invalidateMenus = () => {
 cachedMenus = null;
 cacheTimestamp = null;
};

/**
 * Load menu items from backend & transform for frontend
 * [OK] Filters children FIRST, shows parents with ANY visible children
 */
export const loadMenus = async () => {
 // Return cache if fresh
 if (cachedMenus && cacheTimestamp && 
 Date.now() - cacheTimestamp < CACHE_DURATION) {
 return cachedMenus;
 }

 try {
 const res = await api.get("/menus");
 const raw = res.data.data || [];

 cachedMenus = raw
 .map((item) => {
 return {
 title: item.title,
 key: item.key, // [OK] Include key for permission mapping
 iconStyle: item.icon ? <i className={item.icon} /> : null,
 to: item.to || null,
 allowedRoles: item.allowedRoles || [],
 requiredPermission: item.requiredPermission || "",
 content: (item.children || []).map((child) => ({
 title: child.title,
 key: child.key, // [OK] Include key for permission mapping
 to: child.to || null,
 iconStyle: child.icon ? <i className={child.icon} /> : null,
 allowedRoles: child.allowedRoles || [],
 requiredPermission: child.requiredPermission || "",
 })),
 };
 });

 

 cacheTimestamp = Date.now();
 return cachedMenus;
 } catch (error) {
 console.error("[ERROR] Menu load failed:", error);
 invalidateMenus();
 return [];
 }
};

/**
 * Synchronous getter for sidebar (use with loading state)
 */
export const getMenuList = () => cachedMenus || [];

/**
 * Check if menus are loading from cache/backend
 */
export const isMenuCacheFresh = () => 
 cachedMenus && cacheTimestamp && 
 Date.now() - cacheTimestamp < CACHE_DURATION;
